import { ApplicationsGroupsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/applications_groups/Applications_groupsServiceClientPb';
import {
  ApplicationsGroup,
  CreateApplicationsGroupRequest,
  CreateApplicationsGroupResponse,
  DeleteApplicationsGroupRequest,
  DeleteApplicationsGroupResponse,
  GetApplicationsGroupByCodeRequest,
  ListApplicationsGroupsRequest,
  ListApplicationsGroupsResponse,
  UpdateApplicationsGroupRequest,
  UpdateApplicationsGroupResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/applications_groups/applications_groups_pb';

export type ApplicationsGroupsExportClasses = {
  ApplicationsGroupsServiceClient: typeof ApplicationsGroupsServiceClient;
  ApplicationsGroup: typeof ApplicationsGroup;
  CreateApplicationsGroupRequest: typeof CreateApplicationsGroupRequest;
  CreateApplicationsGroupResponse: typeof CreateApplicationsGroupResponse;
  DeleteApplicationsGroupRequest: typeof DeleteApplicationsGroupRequest;
  DeleteApplicationsGroupResponse: typeof DeleteApplicationsGroupResponse;
  GetApplicationsGroupByCodeRequest: typeof GetApplicationsGroupByCodeRequest;
  ListApplicationsGroupsRequest: typeof ListApplicationsGroupsRequest;
  ListApplicationsGroupsResponse: typeof ListApplicationsGroupsResponse;
  UpdateApplicationsGroupRequest: typeof UpdateApplicationsGroupRequest;
  UpdateApplicationsGroupResponse: typeof UpdateApplicationsGroupResponse;
};

export const applicationsGroups: ApplicationsGroupsExportClasses = {
  ApplicationsGroupsServiceClient,
  ApplicationsGroup,
  CreateApplicationsGroupRequest,
  CreateApplicationsGroupResponse,
  DeleteApplicationsGroupRequest,
  DeleteApplicationsGroupResponse,
  GetApplicationsGroupByCodeRequest,
  ListApplicationsGroupsRequest,
  ListApplicationsGroupsResponse,
  UpdateApplicationsGroupRequest,
  UpdateApplicationsGroupResponse,
};
